<template>
    <div id="footer1">
        <div class="footerBox">
            <p>Copyright 2024 Calawa Inc. AllRights Reserved</p>
            <p>Website registration number：</p> <!--网站备案号 粤ICP备15004336号 -->
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                
            }
        }
    }
</script>

<style lang="scss" scoped>
    #footer1{
        width: 1260px;

        background-color: #bbb;

        margin:0 auto 0 auto;
        clear: both;

        .footerBox{
            padding: 30px 0 30px;
            text-align: center;
            p{
                font-size: 14px;

                height: 19px;
            }
        }
    }
</style>


